import request from '@/router/axios';

let urlPrefix = '/api/lab/labexperiment';

/**
 * 获取列表
 * @param {Number} page
 * @param {Number} limit
 * @param {Object} params
 */
export const getLabExps = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit,
        }
    });
};

export const getLabExpsNoToken = (page, limit, params) => {
    return request(`${urlPrefix}/query/noToken`, {
        params: {
            ...params,
            page,
            limit
        }
    })
}

/**
 * 批量删除
 * @param {Array} data
 */
export const remove = data => {
    return request(`${urlPrefix}/deleteBatchByUid`, {
        data
    }, 'delete');
};

/**
 * 获取对象
 * @param {number} id
 */
export const getEntity = id => {
    return request(`${urlPrefix}/${id}`);
};

/**
 * 添加操作
 * @param {Object} data
 */
export const add = data => {
    return request(urlPrefix, {
        data
    }, 'post');
};

export const moveIndex = (uid = '', type = 'down') => {
    return request(`${urlPrefix}/moveIndex/${uid}/${type}`, {}, 'post')
}

/**
 * 编辑操作
 * @param {Object} data
 */
export const update = data => {
    return request(urlPrefix, {
        data
    }, 'put');
};

// 
/**
 * 根据uid获取实验项目详情
 * @param {*} uid 
 */
 export const getExpSoftInfoByUid = (uid) => {
    return request(`${urlPrefix}/${uid}/expSoftInfo`);
};

/**
 * 批阅（某学生的）报告
 */
export const reviewReports = (uid, data) => {
    // let uid = '74bbb3aab9054dc1b4b5e28d8ca6027c'
    // let data = [
    //     { uid: '87cdae77c3204a69a6e5c21bc4aad7a6', score: 90 },
    //     { uid: '468c721be4b241ddaf66a824ff77bfe8', score: 91 },
    //     { uid: '7702d83aac304b48a331885727030b76', score: 92 },
    //     { uid: '054fc365fa504542be86faf6d11d0bdc', score: 93 }
    // ]
    return request(`${urlPrefix}/${uid}/report/review`, { data }, 'put');
};

/**
 * 查重操作
 * @param {Object} params
 */
export const duplicateCheck = params => {
    return request(`${urlPrefix}/duplicateCheck`, {
        params
    });
};

/**
 * 开始实验
 * @param {String} expUid 课堂实验UID
 * @param {Number} userId 用户ID
 */
export const startExp = ({
    expUid,
    userId
}) => {
    return request(`${urlPrefix}/startExp/${expUid}/${userId}`)
}

/**
 * 获取我的实验详情
 * @param {String} uid
 */
export const getMyExpDetail = (uid) => {
    if (uid == null || uid === "") {
        return Promise.reject(new Error("参数错误"))
    }
    return request(`${urlPrefix}/mine/${uid}`);
};

/**
 * 通过UID获取对象
 * @param {String} uid
 */
export const getEntityByUid = uid => {
    return request(`${urlPrefix}/${uid}/detail`);
};

/**
 * 老师获取实验项目详情
 * @param {String} uid
 */
export const teacherDetailExp = (uid) => {
    return request(`${urlPrefix}/teacher/detail/${uid}`);
};

/**
 * 教师获取个人实验下的学生完成情况
 * @param {Number} page 当前页码
 * @param {Number} limit 每页条目数
 * @param {Object} params 筛选条件
 * @param {String} params.expUid 实验UID
 * @param {Number} params.status 状态 0 未提交，1已提交
 */
export const getExpStudentList = (page, limit, params) => {
    return request(`${urlPrefix}/student/exps`, {
        params: {
            ...params,
            page,
            limit
        }
    });
};

/**
 * 获取当前批阅的报告信息
 * @param {String} uid
 */
export const getMaskExpInfo = (uid) => {
    return request(`${urlPrefix}/${uid}/mark/info`);
};

/**
 * 给报告打分
 * @param {String} uid
 * @param {Number} score
 */
export const setReportScore = (uid, score) => {
    return request(`${urlPrefix}/score`, {
        params: {
            uid,
            score
        }
    }, 'put');
};

/**
 * 获取学生的实验报告UID
 * @param {String} uid
 */
export const getMyReport = uid => {
    return request(`${urlPrefix}/report`, {
        params: {
            uid
        }
    });
};

/**
 * 获取所有实验
 */
export const getExpAllList = () => {
    return request(`${urlPrefix}/all`);
};

/**
 * 获取热度课堂实验排行榜
 * @param {Number} len
 * @param {Object} params
 */
export const getTopClassExpList = (len, params) => {
    return request(`${urlPrefix}/getTopList/${len}`, { params })
}

/**
 * 获取某课堂实验统计数据
 * @param {String} uid
 */
export const getClassExpStatistics = uid => {
    return request(`${urlPrefix}/${uid}/statistics`)
}

/**
 * 获取我的实验报告详情
 * @param {String} uid 实验记录UID
 */
export const getMyExpReport = uid => {
    return request(`/api/lab/labexperimentreport/student/report`, {
        params: {
            uid
        }
    });
};

/**
 * 提交报告
 * @param {String} uid
 * @param {Object} data
 */
export const submitReport = (uid, data) => {
    return request(`/api/lab/labexperimentreport/submit/${uid}`, {
        data
    }, 'post');
};
